import * as React from 'react';
import { Modal } from '../../../../../Modal';
import { TaxDeduction } from '../../../../../TaxDeduction';
import * as main from '../../../styles/main.module.scss';
import * as cost from './cost.module.scss';
export const Cost = ({ title, widgetOtlichnik, widgetIndi, sravni }) => {
  const [showModalOtlichnik, setShowModalOtlichnik] = React.useState(false);
  const [showModalIndi, setShowModalIndi] = React.useState(false);
  return (
    <section className={cost.cost} id="user-action">
      <div className="container">
        <h2 className={cost.cost__title}>{title}</h2>
        <div className={cost.cost__row}>
          <div className={cost.cost__col}>
            <div className={cost.cost__wrapper}>
              <div className={cost.cost__info}>
                <h3 className={cost.cost__heading}>Пакет «Отличник»</h3>
                <ul className={cost.cost__list}>
                  <li className={cost.cost__item}>Доступ к курсу на&nbsp;2&nbsp;года</li>
                  <li className={cost.cost__item}>
                    Беспроцентная рассрочка
                    <br />
                    на&nbsp;10&nbsp;месяцев
                  </li>
                </ul>
                <div className={cost.cost__priceWrapper}>
                  <p className={cost.cost__priceText}>Стоимость</p>
                  <p>
                    <span className={cost.cost__priceColor}>99&nbsp;900&nbsp;₽</span>
                  </p>
                </div>
              </div>

              <div className={`${cost.cost__blockBtn} block-btn`}>
                <button
                  className={`${cost.cost__btn} ${main.mainBtn}`}
                  onClick={() => {
                    setShowModalOtlichnik(true);
                  }}
                >
                  Купить
                </button>
              </div>
            </div>
          </div>

          <div className={cost.cost__col}>
            <div className={cost.cost__wrapper}>
              <div className={cost.cost__info}>
                <h3 className={cost.cost__heading}>Индивидуальное обучение</h3>
                <ul className={cost.cost__list}>
                  <li className={cost.cost__item}>Доступ к курсу на&nbsp;2&nbsp;года</li>
                  <li className={cost.cost__item}>165&nbsp;академических часов индивидуальных занятий</li>
                </ul>
                <div className={cost.cost__priceWrapper}>
                  <p className={cost.cost__priceText}>Стоимость</p>
                  <p>
                    <span className={cost.cost__priceColor}>1&nbsp;500&nbsp;000&nbsp;₽</span>
                  </p>
                </div>
              </div>

              <div className={`${cost.cost__blockBtn} block-btn`}>
                <button
                  className={`${cost.cost__btn} ${main.mainBtn}`}
                  onClick={() => {
                    setShowModalIndi(true);
                  }}
                >
                  Записаться на консультацию
                </button>
              </div>
            </div>
          </div>
        </div>
        <p className={cost.cost__undertext}>Все наши курсы можно оплатить материнским капиталом</p>
        <TaxDeduction className={cost.cost__undertext} linkInner={sravni} />
      </div>
      <Modal
        open={showModalOtlichnik}
        onClose={() => {
          setShowModalOtlichnik(false);
        }}
      >
        {widgetOtlichnik}
      </Modal>

      <Modal
        open={showModalIndi}
        onClose={() => {
          setShowModalIndi(false);
        }}
      >
        {widgetIndi}
      </Modal>
    </section>
  );
};
